import type { PersonaOpportunitySetListPage } from "../api/persona-opportunity-sets.api";

/**
 * Set ids removed by Stop before the worker soft-delete lands.
 * List invalidations (delete, poll) must not flash those rows back as GENERATING.
 */
const suppressedPersonaSetIds = new Set<string>();

export function suppressPersonaOpportunitySetId(setId: string): void {
  suppressedPersonaSetIds.add(setId);
}

export function unsuppressPersonaOpportunitySetId(setId: string): void {
  suppressedPersonaSetIds.delete(setId);
}

/** Test helper — production code clears entries when the server omits them. */
export function clearPersonaOpportunitySetSuppressions(): void {
  suppressedPersonaSetIds.clear();
}

export function applyPersonaOpportunitySetListSuppression(
  page: PersonaOpportunitySetListPage,
): PersonaOpportunitySetListPage {
  for (const id of [...suppressedPersonaSetIds]) {
    if (!page.items.some((set) => set.id === id)) {
      suppressedPersonaSetIds.delete(id);
    }
  }
  if (suppressedPersonaSetIds.size === 0) return page;
  return {
    ...page,
    items: page.items.filter((set) => !suppressedPersonaSetIds.has(set.id)),
  };
}
